import style from "./AboutTab.module.css"
import About1 from "./About1.js"
import About2 from "./About2.js"
import About3 from "./About3.js"
import About4 from "./About4.js"
import About5 from "./About5.js"
import { useState } from 'react';

export default function Main() {

  const [currentActive, setCurrentActive] = useState(0);

  return (
    <>
      <div>
        <div className={style.abouttop}></div>
        <div className={style.tabbox}>
          <div className={style.tabheader}>
            <a className={currentActive == 0 ? style.active : ''} onClick={() => { setCurrentActive(0) }} >公司简介</a>
            <a className={currentActive == 1 ? style.active : ''} onClick={() => { setCurrentActive(1) }}>组织机构</a>
            <a className={currentActive == 2 ? style.active : ''} onClick={() => { setCurrentActive(2) }}>荣誉资质</a>
            <a className={currentActive == 3 ? style.active : ''} onClick={() => { setCurrentActive(3) }}>发展历程</a>
            <a className={currentActive == 4 ? style.active : ''} onClick={() => { setCurrentActive(4) }}>加入我们</a>
          </div>
          <div className={style.tabbody}>
            {currentActive == 0 && <About1 />}
            {currentActive == 1 && <About2 />}
            {currentActive == 2 && <About3 />}
            {currentActive == 3 && <About4 />}
            {currentActive == 4 && <About5 />}

          </div>
        </div>
      </div>

    </>
  );
}

